import nursePacks from './preAssessmentNurseTranslations.json' with { type: 'json' };

// Route parity for *existing* 16-language machine-assisted editorial drafts.
// The versioned patientGuides content remains the primary clinical guide.
// Do not create translations for legacy clinical facts from this projection.
const PATHS = Object.freeze([
  ['title', 'title'],
  ['plainEnglishTitle', 'plainEnglishTitle'],
  ['description', 'description'],
  ['whenYouSeeThem', 'whenYouSeeThem'],
]);
export const PREASSESSMENT_LEGACY_ROUTE_LANGUAGES =
  Object.freeze(Object.keys(nursePacks.translations).sort());
export const PREASSESSMENT_LEGACY_ROUTE_FIELDS =
  Object.freeze(PATHS.map(([field]) => field));

const languageId = value => String(value || '').trim().toLowerCase().split('-')[0];

export function preAssessmentLegacyRouteText(locale, path) {
  const prefix = 'items.pre_assessment_nurse.';
  if (typeof path !== 'string' || !path.startsWith(prefix)) return undefined;
  const field = path.slice(prefix.length);
  const mapping = PATHS.find(([key]) => key === field);
  return mapping ? nursePacks.translations[languageId(locale)]?.[mapping[1]] : undefined;
}

export function installPreAssessmentLegacyRouteTranslations(i18n, language, namespace) {
  const locale = languageId(language);
  if (namespace !== 'roles' || !nursePacks.translations[locale]) return;
  for (const [roleField, sourceField] of PATHS) {
    const path = 'items.pre_assessment_nurse.' + roleField;
    const current = i18n.getResource(locale, namespace, path);
    const existingDraft = nursePacks.translations[locale][sourceField];
    // A locale field, including a professional release, always wins. This
    // fills only gaps otherwise falling back silently to English.
    if ((!current || typeof current !== 'string' || !current.trim())
      && typeof existingDraft === 'string' && existingDraft.trim()) {
      i18n.addResource(locale, namespace, path, existingDraft);
    }
  }
}
